<template>
  <div class="component-wrapper d-flex flex-column align-center pa-5">
    <img class="logo mb-4" src="@/assets/logo.svg" />

    <template>
      <v-btn-toggle rounded v-model="type" color="primary" class="mb-6" mandatory>
        <v-btn rounded outlined class="mr-2 custom-rounded-btn" width="167px"> {{ $t('program') }} </v-btn>

        <v-btn rounded class="custom-rounded-btn" outlined width="167px"> {{ $t('liveBroadcast') }} </v-btn>
      </v-btn-toggle>

      <Program v-if="type == 0" />

      <Live v-if="type == 1" />
    </template>

    <v-btn
      rounded
      
      @click="onCustomInstall"
      v-if="showInstallBtn"
      depressed
      class="mt-8 primary custom-rounded-btn"
      >{{ $t('appInstallation') }}</v-btn
    >
    <!-- <LanguageSelector /> -->

  </div>
</template>

<script>
import Program from "@/views/home/Program";
import Live from "@/views/home/Live";
import LanguageSelector from "../../components/LanguageSelector.vue";


export default {
  components: {
    Program,
    Live,
    LanguageSelector
  },
  data() {
    return {
      type: 0,
      installEvent: null,
      showInstallBtn: false,
      isDevelopment: process.env.NODE_ENV == "development",
      isMobile: navigator.userAgentData.mobile,
    };
  },
  async created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installEvent = e;
      this.showInstallBtn = true;
    });
  },
  computed: {
    isPWA() {
      const isStandalone = window.matchMedia(
        "(display-mode: standalone)"
      ).matches;

      if (navigator.standalone || isStandalone) {
        return true;
      }

      return false;
    },
  },
  methods: {
    async onCustomInstall() {
      this.installEvent.prompt();

      const choiceResult = await this.installEvent.userChoice;

      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");

      } else {
        console.log("User dismissed the install prompt");
      }
    },
    onOpenApp() {
      window.open("https://testing-5b63a.web.app/");
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 30px;
}

.custom-rounded-btn {
  border-radius: 9999px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  height: 40px !important;
  font-size: 16px !important;
}

</style>
